<h1>Manual Import</h1>
<app-importer #importer [mode]="mode" (cardsImported)="importCards($event)"></app-importer>
<span class="actions">
    <button mat-raised-button color="warn" *ngIf="dialogRef" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="triggerImport()">Import</button>
</span>